module.exports = __webpack_public_path__ + "img/img8.55fb5606.png";